module.exports = __webpack_public_path__ + "img/illu-swamp.2f24ed2b.svg";